import { inject, Pipe, PipeTransform } from '@angular/core';

import { BreakpointObserver } from '@angular/cdk/layout';
import { distinctUntilChanged, map, Observable } from 'rxjs';

// const BREAKPOINTS = {
//   [Breakpoints.XSmall]: 'XSmall',
//   [Breakpoints.Small]: 'Small',
//   [Breakpoints.Medium]: 'Medium',
//   [Breakpoints.Large]: 'Large',
//   [Breakpoints.XLarge]: 'XLarge'
// } as const;

/**
 * Returns a boolean indicating whether given
 * feature is enabled for this tenant
 *
 * Usage:
 *  'feature-name' | hasFeature
 */
@Pipe({
  name: 'mediaMatch',
  standalone: true,
})
export class MediaMatchPipe implements PipeTransform {
  private breakpointObserver = inject(BreakpointObserver);

  transform(value: string): Observable<boolean> {
    return this.breakpointObserver.observe(value).pipe(
      distinctUntilChanged(),
      map((result) => result.matches),
    );
  }
}
